export default "__VITE_ASSET__ByuRgvPz__"